import * as yup from "yup";
import { useTranslation } from "react-i18next";
import BaseForm from "../../../../../../../shared/components/form/BaseForm";
import FormInput from "../../../../../../../shared/components/input/FormInput";
import FormSelect from "../../../../../../../shared/components/select/FormSelect";

const CreateClientProductForm = ({ categories, onSubmitHandler }) => {
  const { t } = useTranslation();

  const validationSchema = yup.object({
    category: yup
      .string()
      .required(
        t("clients.detail.tabs.products.createForm.fields.category.required"),
      ),
    code: yup
      .string()
      .required(
        t("clients.detail.tabs.products.createForm.fields.code.required"),
      ),
    name: yup
      .string()
      .required(
        t("clients.detail.tabs.products.createForm.fields.name.required"),
      ),
  });

  const defaultValues = {
    category: "",
    code: "",
    name: "",
    description: "",
  };

  return (
    <BaseForm
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      onSubmitHandler={onSubmitHandler}
    >
      <FormSelect
        name="category"
        label={t(
          "clients.detail.tabs.products.createForm.fields.category.label",
        )}
        options={categories}
      />
      <FormInput
        name="code"
        label={t("clients.detail.tabs.products.createForm.fields.code.label")}
        required
      />
      <FormInput
        name="name"
        label={t("clients.detail.tabs.products.createForm.fields.name.label")}
        required
      />
      <FormInput
        name="description"
        label={t(
          "clients.detail.tabs.products.createForm.fields.description.label",
        )}
      />
    </BaseForm>
  );
};

export default CreateClientProductForm;
